import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Guides from './pages/Guides';
import News from './pages/News';
import Contact from './pages/Contact';
import GettingStarted from './pages/guides/GettingStarted';
import WelcomeBonuses from './pages/guides/WelcomeBonuses';
import ChoosingRightCasino from './pages/guides/ChoosingRightCasino';
import PaymentMethods from './pages/guides/PaymentMethods';
import ResponsibleGambling from './pages/guides/ResponsibleGambling';
import WageringRequirements from './pages/guides/WageringRequirements';
import LiveDealerGames from './pages/guides/LiveDealerGames';
import SlotGamesStrategy from './pages/guides/SlotGamesStrategy';
import TableGamesBasics from './pages/guides/TableGamesBasics';
import NewUKGamblingRegulations from './pages/news/NewUKGamblingRegulations';
import Top5SlotGames from './pages/news/Top5SlotGames';
import LiveDealerGamesFuture from './pages/news/LiveDealerGamesFuture';
import CryptocurrencyPayments from './pages/news/CryptocurrencyPayments';
import MobileAppsVsBrowser from './pages/news/MobileAppsVsBrowser';
import VIPProgramsExplained from './pages/news/VIPProgramsExplained';
import NewGameReleases from './pages/news/NewGameReleases';
import WithdrawalSpeedComparison from './pages/news/WithdrawalSpeedComparison';
import ResponsibleGamblingTools from './pages/news/ResponsibleGamblingTools';
import Reviews from './pages/Reviews';
import Casino888Review from './pages/reviews/888CasinoReview';
import KwiffReview from './pages/reviews/KwiffReview';
import PlazaRoyalReview from './pages/reviews/PlazaRoyalReview';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-dark-black">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/getting-started-online-casinos" element={<GettingStarted />} />
            <Route path="/guides/understanding-welcome-bonuses" element={<WelcomeBonuses />} />
            <Route path="/guides/choosing-right-casino" element={<ChoosingRightCasino />} />
            <Route path="/guides/payment-methods-withdrawals" element={<PaymentMethods />} />
            <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
            <Route path="/guides/understanding-wagering-requirements" element={<WageringRequirements />} />
            <Route path="/guides/live-dealer-games-guide" element={<LiveDealerGames />} />
            <Route path="/guides/slot-games-strategy" element={<SlotGamesStrategy />} />
            <Route path="/guides/table-games-basics" element={<TableGamesBasics />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/new-uk-gambling-regulations" element={<NewUKGamblingRegulations />} />
            <Route path="/news/top-5-slot-games-december" element={<Top5SlotGames />} />
            <Route path="/news/live-dealer-games-future" element={<LiveDealerGamesFuture />} />
            <Route path="/news/cryptocurrency-payments-uk-casinos" element={<CryptocurrencyPayments />} />
            <Route path="/news/mobile-apps-vs-browser-play" element={<MobileAppsVsBrowser />} />
            <Route path="/news/vip-programs-explained" element={<VIPProgramsExplained />} />
            <Route path="/news/new-game-releases-season" element={<NewGameReleases />} />
            <Route path="/news/withdrawal-speed-comparison" element={<WithdrawalSpeedComparison />} />
            <Route path="/news/responsible-gambling-tools-effectiveness" element={<ResponsibleGamblingTools />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/reviews/888-casino-review" element={<Casino888Review />} />
            <Route path="/reviews/kwiff-review" element={<KwiffReview />} />
            <Route path="/reviews/plaza-royal-review" element={<PlazaRoyalReview />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
        <AgeVerification />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
